import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { createRegion } from '../../graphql/facilities/create-region';
import { deleteRegion } from '../../graphql/facilities/delete-region';
import { getRegions } from '../../graphql/facilities/get-regions';
import { getRegion } from '../../graphql/facilities/get-region';
import { queryForRegions } from '../../graphql/facilities/query-for-regions';
import { updateRegion } from '../../graphql/facilities/update-region';
import {
  CreateRegionInput,
  Region,
  RegionConnection,
  RegionSortOrQuery,
  UpdateRegionInput,
} from 'src/app/model/locations/region';
import { RegionBuilderService } from '../builder/region-builder.service';
import { BaseAppSyncService } from '../base-app-sync.service';

@Injectable({
  providedIn: 'root',
})
export class RegionApiService extends BaseAppSyncService {
  protected _regionBuilder = inject(RegionBuilderService);

  getRegions(): Observable<Region[]> {
    return this.query(
      getRegions,
      {},
      (items: any[]) => items.map((i) => this._regionBuilder.buildRegion(i)),
      'getRegions',
      'cache-first'
    );
  }

  queryForRegions(
    limit: number,
    page: number,
    query: RegionSortOrQuery,
    sort: RegionSortOrQuery
  ): Observable<RegionConnection> {
    return this.query(
      queryForRegions,
      { limit, page, query, sort },
      (i: any) => this._regionBuilder.buildRegionConnection(i),
      'queryForRegions'
    );
  }

  getRegion(id: string): Observable<Region> {
    return this.query(
      getRegion,
      { id },
      (i: any) => this._regionBuilder.buildRegion(i),
      'getRegion'
    );
  }

  deleteRegion(id: string): Observable<boolean> {
    return this.mutate(deleteRegion, { id }, (i: any) => true, 'deleteRegion');
  }

  updateRegion(id: string, regionInput: UpdateRegionInput): Observable<Region> {
    return this.mutate(
      updateRegion,
      { id, input: regionInput },
      (i: any) => this._regionBuilder.buildRegion(i),
      'updateRegion'
    );
  }

  createRegion(regionInput: CreateRegionInput): Observable<Region> {
    return this.mutate(
      createRegion,
      { input: regionInput },
      (i: any) => this._regionBuilder.buildRegion(i),
      'createRegion'
    );
  }
}
